<template>
  <!-- 仪表图图表 -->
  <div ref="echarts" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

<script>
// datas 图表数据源
// colorList 颜色值
export default {
  props: [ "datas", "colorList", "circleRadius"],
  data() {
    return {
      pieEcharts: "",
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption( newValue, this.colorList);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    // if (this.datas) {
    this.setPieOption( this.datas, this.colorList);
    // }
  },
  methods: {
    setPieOption(datas, colorList) {
      datas = datas || datas <= 0 ? Number(datas) : 0;
      if (isNaN(datas)) datas = 0;
      this.pieEcharts = this.$echarts.init(this.$refs.echarts);
      if (!colorList) {
        colorList = ["#FFAB91", "#FD7347"];
      }
      let seriesData = [
        {
          type: "gauge",
          center: ["50%", "60%"],
          radius: this.circleRadius ? this.circleRadius : "65%",
          startAngle: 200,
          endAngle: -20,
          min: 0,
          max: 100,
          splitNumber: 10, // 调节仪表盘外圈的数值，数值和最大值最小值除余有关
          itemStyle: {
            color: colorList[0],
          },
          progress: {
            show: true,
            width: 60,
          },
          pointer: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: [
                [
                  0.02,
                  this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: "#bcc2cf",
                    },
                    {
                      offset: 0.5,
                      color: "#bcc2cf",
                    },
                    {
                      offset: 1,
                      color: "#bcc2cf",
                    },
                  ]),
                ],
                [
                  1,
                  this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: "rgba(255,255,255, 0.3)",
                    },
                    {
                      offset: 0.5,
                      color: "rgba(255,255,255, 0.05)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255,255,255, 0.05)",
                    },
                  ]),
                ],
              ],
            },
          },
          axisTick: {
            distance: -48,
            splitNumber: 5,
            lineStyle: {
              width: 1,
              color: "#bcc2cf",
            },
          },
          splitLine: {
            distance: -53,
            length: 14,
            lineStyle: {
              width: 2,
              color: "#bcc2cf",
            },
          },
          axisLabel: {
            distance: -25,
            color: "#bcc2cf",
            fontSize: 20,
          },
          anchor: {
            show: false,
          },
          title: {
            show: false,
          },
          detail: {
            valueAnimation: true,
            width: "60%",
            lineHeight: 40,
            borderRadius: 8,
            offsetCenter: [0, "-15%"],
            fontSize: this.circleRadius ? 40 : 25,
            fontWeight: "bolder",
            formatter: "{value} %",
            color: "auto",
          },
          data: [
            {
              value: datas,
            },
          ],
        },
        {
          type: "gauge",
          center: ["50%", "60%"],
          radius: this.circleRadius ? this.circleRadius : "65%",
          startAngle: 200,
          endAngle: -20,
          min: 0,
          max: 100,
          itemStyle: {
            color: colorList[1],
          },
          progress: {
            show: true,
            width: 20,
          },
          pointer: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 30,
              color: [
                [
                  0.02,
                  this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: "#7D818E",
                    },
                    {
                      offset: 0.5,
                      color: "#7D818E",
                    },
                    {
                      offset: 1,
                      color: "#4B5163",
                    },
                  ]),
                ],
                [
                  1,
                  this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: "rgba(255,255,255, 0.1)",
                    },
                    {
                      offset: 0.5,
                      color: "rgba(255,255,255, 0.05)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255,255,255, 0.05)",
                    },
                  ]),
                ],
              ],
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          detail: {
            show: false,
          },
          data: [
            {
              value: datas,
            },
          ],
        },
      ];
      if (this.circleRadius)
        seriesData.push({
          type: "gauge",
          center: ["50%", "60%"],
          radius: this.circleRadius ? this.circleRadius : "65%",
          startAngle: 200,
          endAngle: -20,
          pointer: {
            show: false,
          },
          axisLine: {
            // 坐标轴线
            lineStyle: {
              // 属性lineStyle控制线条样式
              color: [[1, "#bfcbd9"]],
              width: 60,
            },
          },
          splitLine: {
            //分隔线样式
            show: false,
          },
          axisLabel: {
            //刻度标签
            show: false,
          },
          axisTick: {
            //刻度样式
            show: false,
          },
          detail: {
            show: false,
          },
          data: [
            {
              value: 100,
            },
          ],
        });

      this.pieOption = {
        tooltip: {
          trigger: "item",
          confine: true, // 浮窗限制在图表内
          backgroundColor: "rgba(64, 80, 118, 0.8)", // 通过设置rgba调节背景颜色与透明度
          borderColor: "rgba(64, 80, 118, 0.8)",
          color: "#fff",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        series: seriesData,
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener("resize", () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
